import { useState } from "react";
import { Link } from "react-router-dom";

const footerLinks: Record<string, { label: string; href: string }[]> = {
  "Atendimento ao Cliente": [
    { label: "Contate-nos", href: "#" },
    { label: "Perguntas frequentes", href: "#" },
    { label: "Devoluções", href: "#" },
  ],
  "Sobre a Clientizah": [
    { label: "Nossa história", href: "#" },
    { label: "Imprensa", href: "#" },
    { label: "Afiliados", href: "#" },
  ],
  "Ajuda e informações": [
    { label: "Política de Privacidade", href: "/politica-de-privacidade" },
    { label: "Política de Cookies", href: "#" },
    { label: "Nossos Cursos", href: "/nossos-produtos" },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [openSections, setOpenSections] = useState<string[]>([]);
  const [contactOpen, setContactOpen] = useState(false);

  const toggleSection = (section: string) => {
    setOpenSections((prev) =>
      prev.includes(section) ? prev.filter((s) => s !== section) : [...prev, section]
    );
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    try {
      const formData = new URLSearchParams();
      formData.append("email", email);
      await fetch("https://readdy.ai/api/form/d70rb0hqa83q0hmd1fug", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <footer className="bg-[#f5f2ef]">

      {/* Contact Slide Drawer */}
      <>
        {/* Overlay */}
        <div
          className={`fixed inset-0 bg-black/40 z-40 transition-opacity duration-300 ${contactOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
          onClick={() => setContactOpen(false)}
        />
        {/* Drawer */}
        <div
          className={`fixed top-0 right-0 h-full w-full max-w-sm bg-white z-50 shadow-xl flex flex-col transition-transform duration-300 ease-in-out ${contactOpen ? "translate-x-0" : "translate-x-full"}`}
        >
          {/* Header */}
          <div className="flex items-center justify-between px-8 py-7 border-b border-gray-100">
            <div>
              <p className="text-xs tracking-[0.3em] uppercase text-gray-400 mb-1">Fale conosco</p>
              <h3 className="text-lg font-light tracking-tight text-black">Atendimento Clientizah</h3>
            </div>
            <button
              onClick={() => setContactOpen(false)}
              className="w-9 h-9 flex items-center justify-center border border-gray-200 hover:bg-black hover:text-white hover:border-black transition cursor-pointer rounded-sm"
            >
              <i className="ri-close-line text-base"></i>
            </button>
          </div>

          {/* Body */}
          <div className="flex-1 overflow-y-auto px-8 py-8 space-y-8">

            {/* Email */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#f5f2ef] rounded-sm flex-shrink-0">
                <i className="ri-mail-line text-[#c4a882] text-lg"></i>
              </div>
              <div>
                <p className="text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-1">E-mail de Suporte</p>
                <a
                  href="mailto:suporte@clientizah.com.br"
                  className="text-sm font-medium text-black hover:text-[#c4a882] transition"
                >
                  suporte@clientizah.com.br
                </a>
                <p className="text-xs text-gray-400 mt-1 leading-relaxed">
                  Respondemos em até 24h úteis
                </p>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-100" />

            {/* Instagram */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#f5f2ef] rounded-sm flex-shrink-0">
                <i className="ri-instagram-line text-[#c4a882] text-lg"></i>
              </div>
              <div>
                <p className="text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-1">Instagram</p>
                <a
                  href="https://instagram.com/clientizah"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="text-sm font-medium text-black hover:text-[#c4a882] transition"
                >
                  @clientizah
                </a>
                <p className="text-xs text-gray-400 mt-1 leading-relaxed">
                  Dicas, conteúdos e novidades todos os dias
                </p>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-100" />

            {/* Horário */}
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#f5f2ef] rounded-sm flex-shrink-0">
                <i className="ri-time-line text-[#c4a882] text-lg"></i>
              </div>
              <div>
                <p className="text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-1">Horário de Atendimento</p>
                <p className="text-sm text-black">Segunda a Sexta</p>
                <p className="text-xs text-gray-400 mt-0.5">09h às 18h (horário de Brasília)</p>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-100" />

            {/* Nota */}
            <div className="bg-[#faf9f7] rounded-sm p-5 border border-[#ede9e3]">
              <p className="text-xs text-gray-500 leading-relaxed">
                Para dúvidas sobre o curso, acesso à plataforma ou emissão de certificado, envie um e-mail para{" "}
                <a href="mailto:suporte@clientizah.com.br" className="text-[#c4a882] font-medium">
                  suporte@clientizah.com.br
                </a>{" "}
                com seu nome completo e CPF para agilizarmos o atendimento.
              </p>
            </div>
          </div>

          {/* Footer CTA */}
          <div className="px-8 py-6 border-t border-gray-100">
            <a
              href="mailto:suporte@clientizah.com.br"
              className="w-full whitespace-nowrap block text-center bg-black text-white text-xs tracking-widest uppercase font-semibold py-4 hover:bg-[#c4a882] transition-colors cursor-pointer rounded-sm"
            >
              Enviar E-mail
            </a>
          </div>
        </div>
      </>

      {/* Newsletter */}
      <div className="bg-black px-6 md:px-16 py-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-white/50 mb-2">Fique por dentro</p>
            <h3 className="text-2xl font-light text-white tracking-tight">
              Assine a Newsletter da Clientizah
            </h3>
            <p className="text-white/50 text-sm mt-2">
              Conteúdos exclusivos, tendências e novidades — entregues toda semana.
            </p>
          </div>
          <div className="w-full lg:max-w-md">
            {submitted ? (
              <div className="text-white text-sm tracking-wide py-4 border-b border-white/20">
                <i className="ri-check-line mr-2 text-green-400"></i>
                Obrigada por assinar a newsletter da Clientizah!
              </div>
            ) : (
              <form
                data-readdy-form
                id="newsletter-footer"
                onSubmit={handleSubmit}
                className="flex items-stretch border-b border-white/30 focus-within:border-white transition"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Digite seu endereço de e-mail"
                  required
                  className="flex-1 bg-transparent text-white text-sm placeholder-white/40 outline-none py-4 tracking-wide"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap text-xs tracking-widest uppercase text-white hover:text-white/60 transition cursor-pointer pl-4"
                >
                  Assinar
                </button>
              </form>
            )}
            <p className="text-white/30 text-[11px] mt-3 leading-relaxed">
              Ao assinar, você concorda com nossa Política de Privacidade. Cancele a qualquer momento.
            </p>
          </div>
        </div>
      </div>

      {/* Footer links */}
      <div className="px-6 md:px-16 py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
            {/* Brand column */}
            <div>
              <p className="font-bold tracking-[0.25em] text-black text-lg mb-4">CLIENTIZAH</p>
              <p className="text-gray-500 text-xs leading-relaxed mb-6">
                Especialistas em varejo, vendas e experiência do cliente — transformando negócios em todo o Brasil.
              </p>
              <div className="flex items-center gap-4">
                {["ri-instagram-line", "ri-twitter-x-line", "ri-pinterest-line", "ri-facebook-line"].map((icon) => (
                  <button key={icon} className="w-8 h-8 flex items-center justify-center border border-gray-200 hover:border-black hover:bg-black hover:text-white transition cursor-pointer">
                    <i className={`${icon} text-sm`}></i>
                  </button>
                ))}
              </div>
            </div>

            {/* Links columns */}
            {Object.entries(footerLinks).map(([section, links]) => (
              <div key={section}>
                <button
                  onClick={() => toggleSection(section)}
                  className="w-full flex items-center justify-between md:cursor-default cursor-pointer md:pointer-events-none"
                >
                  <h5 className="text-xs tracking-widest uppercase font-semibold text-black mb-0 md:mb-5">
                    {section}
                  </h5>
                  <i className={`ri-${openSections.includes(section) ? "subtract" : "add"}-line text-xs md:hidden`}></i>
                </button>
                <ul className={`space-y-3 mt-4 md:mt-0 ${openSections.includes(section) ? "block" : "hidden md:block"}`}>
                  {links.map((link, i) => {
                    if (section === "Atendimento ao Cliente" && link.label === "Contate-nos") {
                      return (
                        <li key={`${section}-${i}`}>
                          <button
                            onClick={() => setContactOpen(true)}
                            className="text-gray-500 text-xs hover:text-black transition tracking-wide cursor-pointer bg-transparent border-0 p-0 text-left"
                          >
                            {link.label}
                          </button>
                        </li>
                      );
                    }
                    return (
                      <li key={`${section}-${i}`}>
                        {link.href.startsWith("/") ? (
                          <Link
                            to={link.href}
                            className="text-gray-500 text-xs hover:text-black transition tracking-wide"
                          >
                            {link.label}
                          </Link>
                        ) : (
                          <a
                            href={link.href}
                            className="text-gray-500 text-xs hover:text-black transition tracking-wide"
                          >
                            {link.label}
                          </a>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>

          {/* Country selector + copyright */}
          <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 border border-gray-200 px-4 py-2 cursor-pointer hover:border-black transition">
              <i className="ri-global-line text-sm text-gray-500"></i>
              <span className="text-xs tracking-wide text-gray-500">Brasil (BRL)</span>
              <i className="ri-arrow-down-s-line text-xs text-gray-400"></i>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-3 text-center">
              <p className="text-[11px] text-gray-400 tracking-wide">
                &copy; 2025 Clientizah. Todos os direitos reservados.
              </p>
              <span className="hidden md:inline text-gray-300">|</span>
              <Link to="/politica-de-privacidade" className="text-[11px] text-gray-400 hover:text-black transition tracking-wide whitespace-nowrap">
                Política de Privacidade
              </Link>
            </div>

            <div className="flex items-center gap-3">
              <span className="text-[10px] text-gray-400 border border-gray-200 px-2 py-1 tracking-wider">
                VISA
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
